import $ from 'jquery';
import Handlebars from 'handlebars';
import langFromUrl from 'lib/util/langFromUrl';
import getParamByName from 'lib/getParameterByName';
import tdaConfig from 'lib/util/tda.config';
import zip from 'lib/util/zip';
import PageCache from 'lib/page-cache';
import Slicker from 'components/slicker';
import xformOffersCommon from 'lib/transforms/offers.tmpl.common';
import favorites from 'features/favorites';
import scroller from 'lib/scroller';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import anAddContext from 'lib/analytics/context.add';
import cookies from 'utils/cookies';
import offersFactory from 'lib/services/offers-service';
import 'lib/helpers/offer-bundle';
import txtTemplate from 'components/offers/offer.cards.hbs';

var __tmplCards = Handlebars.compile(txtTemplate);

var __hasRtiDealer = cookies.getItem('dealer_code_rti') === 'true';
var __seriesMap;
var offerStrip;
var offersService = offersFactory(tdaConfig.offers.r2_api_key);

// seriesString is optional
// resolves with an array of series or null
// offerid in QS trumps all other series determining
function __addSeries(seriesString) {
  return new Promise(function (resolve) {
    var offerDetail = getParamByName('offerid');
    if (offerDetail) {
      PageCache.await('offer.results.' + offerDetail)
        .then(function (res) {
          // do ALL offers have this on them? I believe so... but test
          if (res.offerBundle && res.offerBundle.offers.length) {
            var seriesList = res.offerBundle.offers[0].seriesList;
            if (seriesList && seriesList.series.id) {
              resolve([seriesList.series.id]); // return as array. sorry
            }
          } else {
            resolve(null);
          }
        })
        .catch(function (err) {
          offerStrip.handleErrors(err);
        });
    } else if (seriesString) {
      var arr = seriesString.split(',').map(function (item) {
        return item.trim();
      });
      resolve(arr);
    } else {
      resolve(null);
    }
  });
}

offerStrip = {
  /*
    Note: Even though '.component-strip-offer' may exist on offer-detail based RAQ forms,
    This init is NOT invoked. Init is invoked only from within the offers-strip.xsl
    while messy, this is a good thing...
    as we don't want to do offers-strip things unless there's an ACTUAL
    offers-strip COMPONENT in the DOM

    TODO:
    - Account for useLabelCode, useOfferType, zipCode, etc datum configs.
    - what is 'useSeriesCode supposed to do? All the vehicle info pages have it
      set to 'no', and instead provide the seriescode in the series datum directly
  */
  init: function (el, config) {
    var self = this;
    if (tdaConfig.tda.code === 'WWW') {
      return;
    }

    self.$el = $(el);
    self.$strip = $('.offer-cards-slider', self.$el);
    self._config = config;
    self.config = config;

    // wait for seriesMap
    PageCache.await('series.map')
      .then(function (seriesMap) {
        __seriesMap = seriesMap;
        self.load();
      })
      .catch(function (err) {
        self.handleErrors(err);
      });

    $(document).on('click', '.slick-next-btn', function () {
      $('.vehicle-image').each(function () {
        if (this.alt !== "Miscellaneous") {
          $(this).attr({
            src: $(this).attr('data-src')
          }).removeAttr('data-src').removeClass('lazy-v');
        }
      });
    });
  },

  load: function () {
    var self = this;
    var params = self.config.params;
    var defaultSeries = self.defaultSeries();

    // a bit messy, need to do this to see if we have an offer detail
    // if we do, that's how we get our series for the offers strip
    __addSeries(defaultSeries)
      .then(function (res) {
        if (res) self.series = res;
        self.pageSize = params.pageSize ? params.pageSize : '9999';
        self.drawHeading(self.buildHeading());
        self.getOffers();
      })
      .catch(function (err) {
        self.handleErrors(err);
      });

    self.jQuerySlickFix();
  },

  // we need to determine what series to use
  // what param should actually win against the others?
  // I say if it came with a series datum, that trumps all others
  defaultSeries: function () {
    var params = this.config.params;
    var detectQueries = (params.detectQueries === 'true');
    if (params.series) {
      return params.series;
    }
    if (detectQueries) {
      return getParamByName('series');
    }
    return null;
  },

  buildHeading: function () {
    var custom = this._config.params.customHeading;
    if (custom) {
      return custom;
    }
    if (this.series && this.series.length) {
      var displaySeries = __seriesMap[this.series[0]].series_display_name;
      var configTitle = this._config.i18n.hasSeriesTitle;
      var customHeading;
      if (this._config.i18n.lang === 'es') {
        var preposition;
        if (displaySeries === 'Sienna' ||
          displaySeries === 'Tundra' ||
          displaySeries === 'Tacoma' ||
          displaySeries === 'RAV4' ||
          displaySeries === 'Highlander' ||
          displaySeries === '4Runner' ||
          displaySeries === 'Sequoia' ||
          displaySeries === 'Land Cruiser' ||
          displaySeries === 'Highlander Hybrid' ||
          displaySeries === 'RAV4 Hybrid') {
          preposition = 'de la';
        } else {
          preposition = 'del';
        }
        customHeading = configTitle + ' ' + preposition + ' ' + displaySeries;
      } else {
        customHeading = displaySeries + ' ' + configTitle;
      }
      return customHeading;
    }
    return this._config.i18n.defaultTitle;
  },

  drawHeading: function (heading) {
    $('.js-offer-strip-title', this.$el).html(heading);
  },

  getOffers: function () {
    var self = this;
    var cacheId = 'offer.strip';
    var request = {
      tdaCode: tdaConfig.tda.code,
      zipCode: zip.getCookiedDefaultFallback(),
      lang: langFromUrl(),
      pageSize: self.pageSize
    };

    if (self.series) {
      request.series = self.series.toString(); // avalon,avalonhybrid... relies on proper datum config (always has))
    }

    // if Offers Strip component is on the Vehicle Info page, add the series year to the request
    if (self.getYearForVip()) {
      request.year = self.getYearForVip().toString();
    }

    if (!PageCache.hasOrPending('offers.strip')) {
      PageCache.maybeSet(cacheId, offersService.offers().all(request));
    }

    PageCache.await(cacheId)
      .then(function offerStripRes(res) {
        if (!res.containsOffers) {
          self.throwErrors(res.error);
        }
        return xformOffersCommon(res.offerBundle.offers);
      })
      .then(function (offersCommon) {
        self.appendOffers(offersCommon);
      })
      .catch(function (err) {
        self.handleErrors(err);
      });
  },

  // TODO: do we need to hide these appends until slideshow built?
  // so far, nope
  // note: we lose the 'id' on each offer card parent anchor, due to slick taking it over
  appendOffers: function (offers) {
    const context = {
      items: offers,
      params: this.config.params,
      i18n: this.config.i18n
    };
    this.$strip.append(__tmplCards(context));
    // TODO: why lazy on the lazy configs?
    $('img.lazy-v', this.$el).lazy({
      afterLoad: function ($el) {
        $el.css({
          visibility: 'visible'
        });
      }
    });
    this.drawOffersSlider();
    this.addOfferContext(offers);
    this.favListeners();
  },

  drawOffersSlider: function () {
    var offersSlide = new Slicker({
      $slider: this.$strip,
      slickOptions: {
        mobileFirst: true,
        slide: '.card',
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        autoplay: false,
        dots: true,
        paddingBottom: 60,
        tablet: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    });
  },

  addOfferContext: function (offers) {
    var self = this;
    var $scope = self.$el;

    // add offer related context
    anAddContext(
      $scope,
      blocks.offerListBlock({
        count: offers.length,
        layout: 'strip'
      }),
      blocks.sectionBlock('Offers Strip')
    );

    if (self.series) {
      anAddContext(
        $scope,
        blocks.seriesBlock({
          series_code: self.series[0]
        })
      );
    }

    // offers context for each
    offers.forEach(function eachOfferCtx(offer) {
      anAddContext(
        $('a[href$="' + offer.id + '"]').parent('div.card-content'),
        blocks.offerBlock(offer)
      );
    });

    scroller.add($scope, {
      after: function () {
        anComponentView($scope);
      }
    });

    anClicks($scope);
  },

  // aarghh, kinda
  favListeners: function () {
    var $favButton = $('.favorite-button', this.$el);
    if (__hasRtiDealer) {
      $favButton.hide();
    } else {
      $favButton.each(function () {
        var $this = $(this);
        favorites.markFav($this);
        $this.on('click', function favClick(e) {
          e.preventDefault();
          favorites.addRemove($this);
        });

        PageCache.on('favs.store', function () {
          favorites.toggleFav($this);
        });
      });
    }
  },

  throwErrors: function throwErr(err) {
    if (err && err[0] === 'Mismatch zip and tda code entered.') {
      throw new Error('zip_mismatch');
    }
    throw new Error('no_offers');
  },

  // todo: just drop offers-strip from page if ANY error at all!?
  handleErrors: function handleErr(err) {
    console.error('err: ', err.name, err.message); // eslint-disable-line no-console
  },

  jQuerySlickFix: function () {
    jQuery.event.special.touchstart = {
      setup: function (_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
          this.addEventListener('touchstart', handle, {
            passive: false
          });
        } else {
          this.addEventListener('touchstart', handle, {
            passive: true
          });
        }
      }
    };
    jQuery.event.special.touchmove = {
      setup: function (_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
          this.addEventListener('touchmove', handle, {
            passive: false
          });
        } else {
          this.addEventListener('touchmove', handle, {
            passive: true
          });
        }
      }
    };
    jQuery.event.special.touchend = {
      setup: function (_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
          this.addEventListener('touchend', handle, {
            passive: false
          });
        } else {
          this.addEventListener('touchend', handle, {
            passive: true
          });
        }
      }
    };
    jQuery.event.special.touchcancel = {
      setup: function (_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
          this.addEventListener('touchcancel', handle, {
            passive: false
          });
        } else {
          this.addEventListener('touchcancel', handle, {
            passive: true
          });
        }
      }
    };
  },

  // determine if we are on the Vehicle Info page
  isVip: function () {
    var isVip = false;
    if ($('div#page-vehicle-info').length) {
      isVip = true;
    }
    return isVip;
  },

  // if on Vehicle Info page, get the year
  getYearForVip: function () {
    var self = this;
    var year;
    if (self.isVip()) {
      year = $('div#page-vehicle-info').data('year');
    }
    return year;
  }

};

export default offerStrip;
